/* eslint-disable react/no-unescaped-entities */
import queryString from 'query-string';
import styled from 'styled-components';
import Button from '../../components/common/Button';
import Footer from '../../components/Footer';
import HeaderOLD from '../../components/OLD_Header';

const Style = styled.div`
    padding: 16px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    min-height: calc(100vh - 350px);
    padding-top: 100px;

    > div.unsuccesful-message {
        margin-bottom: 24px;
    }
    > div.btn-container {
        width: 240px;
    }
`;

const ReservationUnsuccessful = () => {
    const { restaurantSlug } = queryString.parse(window.location.search);

    return (
        <>
            <Style>
                <HeaderOLD inverted />
                <Container>
                    <div className="unsuccesful-message">
                        Whoops... Your reservation didn't go through. Please go
                        to the restaurant's site and try again.
                    </div>
                    <div className="btn-container">
                        <Button
                            onClick={() => {
                                window.location.href = `${
                                    import.meta.env.VITE_DINEOUT_URL
                                }/${restaurantSlug}`;
                            }}
                        >
                            Try again
                        </Button>
                    </div>
                </Container>
            </Style>
            <Footer />
        </>
    );
};

export default ReservationUnsuccessful;
